import {
  SET_WORKSPACE_MEMBERS_LIST,
  SET_WORKSPACE_MEMBERS_LOADING,
  TOGGLE_WORKSPACE_MEMBER_ACTIVE,
} from './workspaceMembers.action';

const emptyPagination = { total: 0, page: 1, limit: 10, totalPages: 0 };

const initialState = {
  activeMembers: [],
  inactiveMembers: [],
  activePagination: { ...emptyPagination },
  inactivePagination: { ...emptyPagination },
  loading: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_WORKSPACE_MEMBERS_LIST:
      if (action.tab === 'inactive') {
        return {
          ...state,
          inactiveMembers: action.members,
          inactivePagination: action.pagination,
        };
      }
      return {
        ...state,
        activeMembers: action.members,
        activePagination: action.pagination,
      };

    case TOGGLE_WORKSPACE_MEMBER_ACTIVE:
      if (action.is_active) {
        // moved from inactive → active: remove from inactive list
        return {
          ...state,
          inactiveMembers: state.inactiveMembers.filter((m) => m._id !== action.wmId),
          inactivePagination: {
            ...state.inactivePagination,
            total: Math.max(0, state.inactivePagination.total - 1),
          },
        };
      }
      // moved from active → inactive: remove from active list
      return {
        ...state,
        activeMembers: state.activeMembers.filter((m) => m._id !== action.wmId),
        activePagination: {
          ...state.activePagination,
          total: Math.max(0, state.activePagination.total - 1),
        },
      };

    case SET_WORKSPACE_MEMBERS_LOADING:
      return { ...state, loading: action.loading };

    default:
      return state;
  }
};
